import { TThunkAction } from '../../types/redux';
import { selectPaymentAmount, selectPaymentInitSource, selectTransactionId } from '../../selectors/checkout';
import { makeYooKassaLinkedCardPayment } from '../../services/yooKassa/makeYooKassaLinkedCardPayment';
import { selectActivePaymentMethod } from '../../selectors/paymentMethods';
import { resetWidget } from '../../actions/common';
import { getResultSuccess } from '../../utils/result';
import { setWidgetError, setWidgetStatus } from '../../actions/layout';
import { EWidgetStatus } from '../../types/redux/layout';

export const payByLinkedCardThunk: TThunkAction = async (dispatch, getState, context) => {
  const { httpApi, resolveWidgetResult } = context;

  const state = getState();
  const { linkedCard } = selectActivePaymentMethod(state);
  const transactionId = selectTransactionId(state);
  const amount = selectPaymentAmount(state);
  const paymentInitSource = selectPaymentInitSource(state);
  const paymentMethod = selectActivePaymentMethod(state);

  const result = await makeYooKassaLinkedCardPayment({
    httpApi,
    amount,
    cardId: linkedCard!.id,
    paymentInitSource,
    transactionId,
  });

  if (result.isSuccess) {
    dispatch(resetWidget());

    resolveWidgetResult(
      getResultSuccess({
        paymentId: result.paymentId,
        transactionId,
        provider: paymentMethod.paymentProvider,
      }),
    );
  } else {
    dispatch(setWidgetError(result.error));

    dispatch(setWidgetStatus(EWidgetStatus.Ready));
  }
};
